(function () {
  angular.module("akitabox.qrCode", [
    "ui.router",
    "ngCookies",
    "akitabox.constants",
    "akitabox.core.router",
    "akitabox.core.services.identity",
    "akitabox.core.services.qrcode",
    "akitabox.ui.dialogs.qrCode.pinSearch",
  ]);
})();
